import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick?: () => void;
};

export const AddButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <AppButton className={styles["add-button"]} onClick={onClick} type="dashed">
      + {t("contactsPage.generalInfo.newTag")}
    </AppButton>
  );
};
